import React from 'react';
import { render } from 'react-dom';
import { makeData, Logo, Tips, round } from '../Utility/utility.js';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import { CustomNav } from '../Components/CustomNav';
import BigCalendar from 'react-big-calendar';
import { BigCalendarEvent } from '../Components/BigCalendarEvent';
import '../Components/BigCalendar.css';
import moment from 'moment';
import Tooltip from 'rc-tooltip';
import Popup from 'react-popup';

export class ExpandedCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      calendar: [],
      showAddReport: false,
      visible: true
    };
  }

  componentWillMount() {
    let currentComponent = this;
    axios
      .get(apiServerUrl + '/calendar', requestOptions())
      .then(function(response) {
        console.log(response);
        let events = [];
        for (var i in response.data) {
          console.log(response.data[i]); //game_id, game_start, opponent, venue
          events.push({
            start: moment(response.data[i].game_start),
            end: moment(response.data[i].game_start).add(1, 'hours'),
            title:
              response.data[i].venue === 'home'
                ? 'vs. ' +
                  response.data[i].opponent +
                  ' ' +
                  moment(response.data[i].game_start).format('LT')
                : '@ ' +
                  response.data[i].opponent +
                  ' ' +
                  moment(response.data[i].game_start).format('LT'),
            description: response.data[i].game_id,
            venue: response.data[i].venue
          });
        }
        console.log(events);
        currentComponent.setState({ calendar: events });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  render() {
    const eventPopup = Popup.create({
      title: null,
      content:
        'This popup uses the create method directly to get more control. This popup demonstrates custom buttons.',
      buttons: {
        left: [
          {
            text: 'Cancel',
            className: 'danger',
            action: function() {
              Popup.alert('You pressed the Cancel btn');

              /** Close this popup. Close will always close the current visible one, if one is visible */
              Popup.close();
            }
          }
        ],
        right: [
          {
            text: 'Alt',
            key: 'ctrl+enter',
            action: function() {
              // Passing true as the second argument to the create method
              // displays it directly, without interupting the queue.
              Popup.create(
                {
                  title: null,
                  content:
                    'I was configured to display right away, without affecting the queue. Closing this will display the previously visible popup.',
                  buttons: {
                    left: ['cancel'],
                    right: []
                  }
                },
                true
              );
            }
          },
          {
            text: 'Save',
            className: 'success',
            action: function() {
              Popup.alert('You pressed the Save btn');

              /** Close this popup. Close will always close the current visible one, if one is visible */
              Popup.close();
            }
          }
        ]
      }
    });
    const MonthEvent = ({ event }) => (
      <div
        id={event.description}
        style={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          height: '5em',
          textAlign: 'center',
          alignItems: 'center',
          borderRadius: '5px',
          width: '100%',
          border: 'none',
          background: event.venue === 'away' ? '#db200f' : '#3174AD'
        }}
      >
        <Popup title={event.title} style={{ display: 'block' }} />
        <div style={{ color: 'white' }}>{event.title}</div>
      </div>
    );
    let components = {
      event: MonthEvent
    };
    BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
    return (
      <div>
        <header className="nav">
          <CustomNav />
        </header>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: '1em',
            padding: '2em',
            background: 'white'
          }}
        >
          <span
            className="previousButton"
            onClick={e => window.history.back()}
            style={{ width: '20%' }}
          >
            &#8678; Back to Previous Page
          </span>

          <div style={{ height: '700px', marginBottom: '2em' }}>
            <BigCalendar
              events={this.state.calendar}
              views={['month', 'agenda']}
              components={{ month: { event: MonthEvent } }}
            />
          </div>
          {/*
        <div style={{margin: '3em', display: 'flex'}}>
        <div style={{marginRight: '2em'}}>
            <span className="addCalendarEvent" onClick={(e) => {this.setState({showAddReport: true})}}>Add Calendar Event</span>
        </div>
        {this.state.showAddReport &&
        <div>
            <input placeholder="Start" />
            <input placeholder="End" />
            <input placeholder="Title" />
            <input placeholder="Description" />
            <input type="submit" value="Save" />
            </div>
        }


    </div>
            */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/BigCalendar.js